/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2013, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/Events',
	'../../widgets/livewidget/nls/StringResources'
], function(Events, stringResources) {
	'use strict';
	var FilterDropAction = null;
	var ACTION_ID = 'filterDropAction';
	FilterDropAction = Events.extend({
		init: function(visualization, metadataColumn, pageContextAPI, dashboardApi, logger) {
			FilterDropAction.inherited('init', this, arguments);
			this.visualization = visualization;
			this.metadataColumn = metadataColumn;
			this.pageContextAPI = pageContextAPI;
			this.dashboardApi = dashboardApi;
			this.logger = logger;
			this.itemContext = {
				itemId: metadataColumn.getId(),
				itemName: metadataColumn.getLabel(),
				dataType: metadataColumn.getDataType(),
				isHierarchy: metadataColumn.isHierarchy(),
				isNamedSet: metadataColumn.isNamedSet(),
				sourceId: this.visualization.getDataSource().getId()
			};

			this.renderModule = this.getEditorModuleName();
			const iconsFeature = this.dashboardApi.getFeature('Icons');
			const filterIcon = iconsFeature.getIcon('common-filter');

			this.toolbarContribution = [{
				name: 'filter',
				text: stringResources.get('toolbarActionFilter'),
				label: stringResources.get('toolbarActionFilter'),
				icon: filterIcon.id,
				type: 'NextView',
				group: ACTION_ID,
				viewModule: this.renderModule,
				viewOptions: this.getViewOptions.bind(this)
			}];
		},

		getActionId: function() {
			return ACTION_ID;
		},

		/**
		 * get the set of availableSort actions setting the selected state to match
		 * the state of the data.
		 * @returns the sort actions and their state.
		 */
		getAvailableActions: function() {
			return this.toolbarContribution;
		},

		getViewOptions: function() {
			var options = {
				height: 300,
				width: 212, // those are hints only; for the placement of the toolbar.
				metadataColumn: this.metadataColumn,
				logger: this.logger,
				dashboardApi: this.dashboardApi,
				visualization: this.visualization,
				itemContext: this.itemContext
			};
			return options;
		},
		/**
		 * @returns a path to the editor dialog to be loaded.
		 */
		getEditorModuleName: function() {
			return 'dashboard-analytics/dialogs/CommonViewWrapper';
		}

	});

	return FilterDropAction;

});
